<script setup lang="ts">
import type { HeroButtonProps } from '.';

import { cn } from '@/utils';

import { Button } from '~/components/ui/button';

import { heroButtonIconVariants, heroButtonVariants } from '.';

const props = withDefaults(defineProps<HeroButtonProps>(), {
	variant: 'default'
});
</script>

<template>
	<Button
		:class="cn(heroButtonVariants({ variant }), props.class)"
		variant="primary"
		size="sm"
	>
		<div :class="heroButtonIconVariants({ variant })">
			<slot name="icon" />
		</div>
		<slot />
	</Button>
</template>
